<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '使用内置方法',
      search,
      api,
      handleTree,
      afterGetDetail,
      ...table,
      ...tree,
      ...dialog,
    }"
    @action="handleAction"
  >
  </zh-table-page>
  <el-dialog v-model="dialogVisible" title="分配角色" width="700">
    <el-descriptions title="">
      <el-descriptions-item label="姓名:">{{
        curScope.nikeName
      }}</el-descriptions-item>
      <el-descriptions-item label="手机号:">{{
        curScope.phone
      }}</el-descriptions-item>
    </el-descriptions>
    <el-transfer
      v-model="transferValue"
      :titles="['角色列表', '拥有角色']"
      :data="transferData"
      :right-default-checked="rightDefaultChecked"
    />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAllocation"> 确认 </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const state = reactive({
      search: [
        {
          label: "姓名",
          placeholder: "姓名",
          value: "nikeName",
        },
        {
          label: "手机号码",
          placeholder: "手机号码",
          value: "phone",
        },

        {
          component: "zh-select",
          label: "是否启用",
          placeholder: "是否启用",
          value: "state",
          url: "",//传api文件下接口方法名
          params: {
            dictType: "center_use_state",
          },
          field: {
            dictValue: "value",
            dictLabel: "label",
          },
        },
      ],
      api: {
        list: "",
        delete: "",
        add: "",
        edit: "",
        detail: "",
        tree: "",
      },
      tree: {
        treeField: {
          organizationName: "label",
        },
      },
      table: {
        columns: [
          { label: "姓名", prop: "nikeName" },
          { label: "手机号码", prop: "phone", width: "110" },
          { label: "邮箱", prop: "email", width: "110" },
          { label: "部门名称", prop: "orgName", width: "110" },
          { label: "岗位名称", prop: "postName", width: "110" },
          { label: "角色", prop: "roleName", width: "110" },
          {
            label: "是否启用",
            prop: "state",
            width: "150",
            scopeComponent: "zh-switch",
          },
          {
            label: "在职状态",
            prop: "workState",
            width: "110",
            scopeFun: (scope) => {
              if (scope.row.workState) {
                return scope.row.workState.desc;
              }
            },
          },
          { label: "创建时间", prop: "createTime", width: "140" },
        ],
        operations: [
          {
            label: "重置密码",
            disabledFun: (row) => {
              return row.state.value == 1 || row.userCode == 1;
            },
          },
          {
            label: "分配角色",
            disabledFun: (row) => {
              return row.state.value == 1 || row.userCode == 1;
            },
          },
          { label: "编辑" },
          { label: "删除", type: "danger" },
        ],
        rowKey: "userCode",
      },
      dialog: {
        dialogForm: [
          {
            label: "姓名",
            placeholder: "请输入姓名",
            value: "nikeName",
          },
          {
            label: "手机号码",
            placeholder: "手机号码默认为登录账号",
            value: "phone",
          },
          {
            label: "账号密码",
            placeholder: "请输入账号密码",
            value: "passWord",
            type: "password",
          },
          {
            component: "zh-tree-select",
            label: "归属部门",
            placeholder: "请选择归属部门",
            value: "orgCode",
            url: "",//传api文件下接口方法名
            field: {
              organizationName: "label",
              organizationCode: "value",
            },
            params: {
              state: 0,
            },
          },
          {
            component: "zh-select",
            label: "岗位名称",
            placeholder: "请选择岗位",
            value: "postCode",
            url: "",//传api文件下接口方法名
            field: {
              postCode: "value",
              postName: "label",
            },
          },
          {
            component: "zh-select",
            label: "角色名称",
            placeholder: "请选择角色",
            value: "roleCode",
            url: "",//传api文件下接口方法名
            field: {
              roleCode: "value",
              roleName: "label",
            },
            multiple: true,
          },
          {
            label: "邮箱",
            placeholder: "请输入邮箱",
            value: "email",
          },
          {
            component: "zh-select",
            label: "是否启用",
            placeholder: "请选择是否启用",
            value: "state",
            url: "",//传api文件下接口方法名
            params: {
              dictType: "center_use_state",
            },
            field: {
              dictValue: "value",
              dictLabel: "label",
            },
            defaultValue: 0,
          },
          {
            component: "zh-select",
            label: "在职状态",
            placeholder: "请选择在职状态",
            value: "workState",
            url: "",//传api文件下接口方法名
            params: {
              dictType: "center_use_workState",
            },
            field: {
              dictValue: "value",
              dictLabel: "label",
            },
          },
          {
            label: "备注信息",
            placeholder: "请输入内容",
            value: "remark",
            type: "textarea",
          },
        ],
        dialogRules: {
          userName: [
            { required: true, message: "姓名不能为空", trigger: "blur" },
          ],
          nikeName: [
            { required: true, message: "姓名不能为空", trigger: "blur" },
          ],
          phone: [
            {
              required: true,
              pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
              message: "请输入正确的手机号码",
              trigger: "blur",
            },
          ],
          orgCode: [
            { required: true, message: "归属部门不能为空", trigger: "blur" },
          ],
          email: [
            {
              type: "email",
              message: "请输入正确的邮箱地址",
              trigger: ["blur", "change"],
            },
          ],
        },
      },
      dialogVisible: false,
      transferData: [],
      transferValue: [],
      rightDefaultChecked: [],
      curScope: null,
    });
    onMounted(() => {
      getRoleList();
    });
    //获取角色列表
    const getRoleList = () => {
      if (proxy.$api.postRoleList) {
        proxy.$api.postRoleList({}).then((res) => {
          if (res.data) {
            state.transferData = res.data;
          }
        });
      }
    };
    /*处理 点击tree时查询列表的传参 */
    const handleTree = (node) => {
      return {
        orgCode: node.organizationCode,
      };
    };
    /*点击列表中行组件触发的方法*/
    const handleAction = (item, type) => {
      if (type === "scope") {
        if (item.userCode == 1) {
          tableRef.value.handleSearch();
          return;
        }
        proxy
          .$confirm("是否修改用户状态?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            proxy.$api.getUser(item.userCode).then((res) => {
              proxy.$api
                .postUserUpdate({
                  userCode: res.data.userCode,
                  state: res.data.state.value == 1 ? 0 : 1,
                })
                .then((res) => {
                  tableRef.value.handleSearch();
                  proxy.$message.success("操作成功");
                });
            });
          })
          .catch(() => {
            tableRef.value.handleSearch();
          });
      } else if (type === "重置密码") {
        handlReset(item);
      } else if (type === "分配角色") {
        handlAllocation(item);
      }
    };
    //处理详情数据
    const afterGetDetail = (data) => {
      return {
        ...data,
        state: data.state?.value ?? 1,
        workState: data.workState?.value ?? 1,
      };
    };
    //点击重置密码
    const handlReset = ({ row }) => {
      ElMessageBox.confirm("是否重置当前用户的密码为默认密码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          proxy.$api
            .postUserResetPassword({ userCode: row.userCode })
            .then((res) => {
              if (res.data.value) {
                proxy.$message.success("操作成功");
              } else {
                proxy.$message.error("操作失败");
              }
            });
        })
        .catch(() => {});
    };
    //点击分配角色
    const handlAllocation = (scope) => {
      state.transferValue = [];
      state.rightDefaultChecked = [];
      if (scope.row.roleCode) {
        // state.rightDefaultChecked = scope.row.roleCode.split(',')
        state.transferValue = scope.row.roleCode.split(",");
      }
      state.curScope = scope.row;
      state.dialogVisible = true;
    };
    //保存分配角色
    const saveAllocation = () => {
      if (state.transferValue.length === 0) {
        proxy.$message.warning("请选择角色");
      } else {
        let data = state.curScope;
        if (data.userCode) {
          delete data.passWord;
        }
        proxy.$api
          .postUserUpdate({
            ...state.curScope,
            roleCode: state.transferValue.join(","),
          })
          .then((res) => {
            if (res.data) {
              tableRef.value.handleSearch();
              proxy.$message.success("操作成功");
              state.dialogVisible = false;
            }
          });
      }
    };
    return {
      ...toRefs(state),
      tableRef,
      handleAction,
      handleTree,
      afterGetDetail,
      saveAllocation,
    };
  },
});
</script>
